// src/components/modals/AddSystemModal.js
import React from 'react';
import { X } from 'lucide-react';

const AddSystemModal = ({
  isOpen,
  onClose,
  onSubmit,
  newSystem,
  onChange,
  isLoading,
  error
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6 border-b flex justify-between items-center">
          <h2 className="text-xl font-bold">Add New System</h2>
          <button 
            onClick={onClose}
            disabled={isLoading}
            className="disabled:opacity-50 hover:bg-gray-100 rounded p-1"
          >
            <X size={24} />
          </button>
        </div>

        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <div>
            <label className="block mb-2 font-medium">System Name *</label>
            <input
              name="system_name"
              value={newSystem.system_name}
              onChange={onChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
              required
              disabled={isLoading}
              placeholder="Enter system name"
            />
          </div>

          <div>
            <label className="block mb-2 font-medium">Description</label>
            <textarea
              name="description"
              value={newSystem.description}
              onChange={onChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
              rows="3"
              disabled={isLoading}
              placeholder="Enter system description"
            />
          </div>

          {error && (
            <div className="p-2 bg-red-100 border border-red-400 text-red-700 rounded text-sm">
              {error}
            </div>
          )}

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={isLoading || !newSystem.system_name.trim()}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Adding...' : 'Add System'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSystemModal;